import { Icon } from "components";
import { LOADER2 } from "icons";
import React from "react";

const Loader = () => {
  return (
    <div className="flex flex-1 justify-center items-center h-screen">
      <Icon icon={LOADER2} className="animate-spin size-6" />
    </div>
  );
};

export default Loader;
